module.exports = __webpack_public_path__ + "img/academy.79063a5c.jpg";